// src/services/ToastService.js

import { Toast } from 'react-bootstrap';
import React from 'react';

class ToastService {
  static positions = {
    TOP_LEFT: 'top-0 start-0',
    TOP_CENTER: 'top-0 start-50 translate-middle-x',
    TOP_RIGHT: 'top-0 end-0',
    MIDDLE_LEFT: 'top-50 start-0 translate-middle-y',
    MIDDLE_CENTER: 'top-50 start-50 translate-middle',
    MIDDLE_RIGHT: 'top-50 end-0 translate-middle-y',
    BOTTOM_LEFT: 'bottom-0 start-0',
    BOTTOM_CENTER: 'bottom-0 start-50 translate-middle-x',
    BOTTOM_RIGHT: 'bottom-0 end-0',
  };

  static types = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    SUCCESS: 'success',
    DANGER: 'danger',
    WARNING: 'warning',
    INFO: 'info',
  };

  static createToast(message, config = {}) {
    const {
      type = this.types.PRIMARY,
      //   position = this.positions.TOP_RIGHT,
      solid = true,
      onClose,
    } = config;

    const bgClass = solid ? `bg-${type}` : `bg-${type}-transparent`;
    const textClass = solid ? 'text-fixed-white' : `text-${type}`;
    const headerClass = `bg-${type} text-fixed-white`;

    return (
      <Toast className={`colored-toast ${bgClass} ${textClass}`} show={true} onClose={onClose}>
        <Toast.Header className={headerClass}>
          <strong className="me-auto">Notification</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    );
  }

  static success(message, config = {}) {
    return this.createToast(message, {
      ...config,
      type: this.types.SUCCESS,
    });
  }

  static error(message, config = {}) {
    return this.createToast(message, {
      ...config,
      type: this.types.DANGER,
    });
  }

  static warning(message, config = {}) {
    return this.createToast(message, {
      ...config,
      type: this.types.WARNING,
    });
  }

  static info(message, config = {}) {
    return this.createToast(message, {
      ...config,
      type: this.types.INFO,
    });
  }
}

export default ToastService;
